import { createAsyncThunk } from "@reduxjs/toolkit";
import { addCms, deleteCms, getCms, getLatestCms, updateCms } from "store/services/cms";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Cms
export const GetAllCmsAction = createAsyncThunk(
  "cms/getAllCms",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getCms(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Update Cms
export const UpdateCmsAction = createAsyncThunk(
  "cms/updateCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateCms(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

//add Cms
export const AddCmsAction = createAsyncThunk(
  "cms/addCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await addCms(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

//delete Cms
export const DeleteCmsAction = createAsyncThunk(
  "cms/deleteCms",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload; 
    try {
      const res = await deleteCms(rest);           
      if (res.status === 1) {
        onSuccess?.(res);                         
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      onError?.(res);                               
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      onError?.(error);                             
      return rejectWithValue(error);
    }
  },
);

export const GetLatestCmsAction = createAsyncThunk(
  "cms/getLatestCms",
  async (payload, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
      const res = await getLatestCms(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({
          type: "error",
          message: getApiMessage(res?.statusCode),
        }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const AddLatestTermsAndConditionAction = createAsyncThunk(
  "cms/addLatestTermsAndCondition",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await addCms(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);


